import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import HeroSection from "./sections/HeroSection";
import StatsBar from "./sections/StatsBar";
import Services from "./sections/Services";
import About from "./sections/About";
import CallToAction from "./sections/CallToAction";
import Testimonials from "./sections/Testimonials";
import MapContactInfo from "./sections/MapContactInfo";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <HeroSection />
      <StatsBar />
      <Services />
      <About />
      <CallToAction />
      <Testimonials />
      <MapContactInfo />
      <Footer />
    </div>;
}